const first_frame = document.querySelector('.frame1')
const second_frame = document.querySelector('.frame2')
const third_frame = document.querySelector('.frame3')
const fourth_frame = document.querySelector('.frame4')

const first_frame_button = document.querySelector('.frame1 .pop-btn')
const second_frame_button = document.querySelector('.frame2 .pop-btn')
const third_frame_button = document.querySelector('.frame3 .pop-btn')
const reset_frame_button = document.querySelector('.frame4 .retake')
// if(document.querySelector('.frame4 .addcart')) {
//   const add_to_cart_button = document.querySelector('.frame4 .addcart')
//   console.log('add_to_cart_button', add_to_cart_button);
// }

// const second_frame_select = document.querySelector('.size-second')
let selected_first = 0
let selected_second = 0

const _sizelist = [
  [0,0,2,2,4,4,6,6,8,8,10,10],
  [0,2,2,4,4,6,6,8,8,10,10,12],
  [2,2,4,4,6,6,8,8,10,10,12,12],
  [4,4,4,6,6,8,8,10,10,12,12,14],
  [6,6,6,6,8,8,10,10,12,12,14,14],
  [8,8,8,8,8,10,10,12,12,14,14,16],
  [10,10,10,10,10,10,12,12,14,14,16,16],
  [12,12,12,12,12,12,12,14,14,16,16,18],
  [14,14,14,14,14,14,14,14,16,16,18,18],
  [16,16,16,16,16,16,16,16,16,18,18,20],
  [18,18,18,18,18,18,18,18,18,18,20,20],
  [20,20,20,20,20,20,20,20,20,20,20,22]
];

if(document.querySelector('.find-fit')) {
  document.querySelector('.find-fit').addEventListener('click', function() {
    document.querySelector('.find-size-container').classList.add('active')
  })
}

document.querySelector('.find-size-container .close').addEventListener('click', function() {
  document.querySelector('.find-size-container').classList.remove('active')
})

first_frame_button.addEventListener('click', function() {
  first_frame.classList.remove('active')
  second_frame.classList.add('active')
})

second_frame_button.addEventListener('click', function() {
  if(document.querySelector('.size-second').value != '') {
    selected_first = parseInt(document.querySelector('.size-second').value)
    second_frame.classList.remove('active')
    third_frame.classList.add('active')
  }
})

third_frame_button.addEventListener('click', function() {
  if(document.querySelector('.size-third').value != '') {
    selected_second = parseInt(document.querySelector('.size-third').value)
    document.querySelector('.customers-size').textContent = `US ${_sizelist[selected_first][selected_second]}`
    third_frame.classList.remove('active')
    fourth_frame.classList.add('active')
    console.log(_sizelist[selected_first][selected_second])
  }
})

reset_frame_button.addEventListener('click', function() {
  fourth_frame.classList.remove('active')
  first_frame.classList.add('active')
})

if(document.querySelector('.frame4 .addcart')) {
  add_to_cart_button = document.querySelector('.frame4 .addcart')
  add_to_cart_button.addEventListener('click', function() {
    document.querySelector('.find-size-container').classList.remove('active')
    fourth_frame.classList.remove('active')
    first_frame.classList.add('active')

    document.querySelector('[name="options[Size]"]').value = _sizelist[selected_first][selected_second];
    document.querySelector('.additional-options').value = _sizelist[selected_first][selected_second];

    const variant_picker = document.querySelector('.additional-options');
    const variant_picker_id = variant_picker.options[variant_picker.selectedIndex].getAttribute('id');

    document.querySelector('.product__info-wrapper .product-variant-id').value = variant_picker_id;
    document.querySelector('.product__info-wrapper .product-form__submit').click()
  })
}